 
/* eslint-disable react-hooks/exhaustive-deps */
import DateTimePicker from "@/components/DateTimerPicker";
import { useInput } from "@/hooks";
import { DTValue } from "@/types";
import { getValueFromDTPicker } from "@/utils";
import classNames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "./style.scss";

interface DateTimeRangePickerProps {
  className?: string;
  from?: DTValue;
  to?: DTValue;
  onChange: (from: DTValue, to: DTValue) => void;
}

export const DateTimeRangePicker: React.FC<DateTimeRangePickerProps> = ({
  className,
  from,
  to,
  onChange,
}) => {
  const [isShowPastTimeRange] = useState<boolean>(false);
  const startTime = useInput(from as DTValue);
  const endTime = useInput(to as DTValue);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const hoverRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isShowPastTimeRange) {
      hoverRef.current?.focus();
    }
  }, [isShowPastTimeRange]);

  useEffect(() => {
    startTime.setValue(from);
    return () => {};
  }, [from]);

  useEffect(() => {
    endTime.setValue(to);
    return () => {};
  }, [to]);

  const handleChange = (start: DTValue, end: DTValue) => {
    startTime.setValue(start);
    endTime.setValue(end);
    if (start && end) {
      if (
        getValueFromDTPicker(start).getTime() <
        getValueFromDTPicker(end).getTime()
      ) {
        setIsDisabled(false);
        onChange(start, end);
      } else {
        setIsDisabled(true);
      }
    }
  };
  return (
    <div
      className={classNames("date-time-range-picker", className)}
      tabIndex={-1}
    >
      <div className="d-flex">
        <div className="date-time-range-picker__label my-auto">From</div>
        <DateTimePicker
          isBefore
          isDisabled={isDisabled}
          offsetTo={"right"}
          value={startTime.value}
          onChange={(e) => handleChange(e, endTime.value)}
        />
      </div>
      <div className="d-flex ms-2">
        <div className="date-time-range-picker__label">To</div>
        <DateTimePicker
          isDisabled={isDisabled}
          offsetTo={"left"}
          value={endTime.value}
          onChange={(e) => handleChange(startTime.value, e)}
        />
      </div>
    </div>
  );
};
